import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import GroupButtonClass from './GroupButton';
import RadioBtnClass from './RadioBtn';
import NestingButton from './NestingButton';
import VerticalBtnGroup from './VerticalBtnGroup';

const GroupButtonContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Button Group' parent='Buttons' title='Button Group' />
      <Row>
        <GroupButtonClass />
        <RadioBtnClass />
        <NestingButton />
        <VerticalBtnGroup />
      </Row>
    </Container>
  );
};
export default GroupButtonContainer;
